import React, { useCallback, useEffect, useState } from "react";
import { Button } from '../../design_system/components/Button/Button.jsx'
import { Loader } from "../../design_system/components/Loader.jsx"
import Avatar from "../../design_system/components/Avatar/Avatar.jsx";
import { windfall_profile } from "../views/profiles/api";
import { profileCache } from "../utils/CacheUtils";

/**
 * Windfall-specific profile card design component.
 * Used with AnProfileCardWrapper HOC.
 * 
 * @param {Object} props.prospect 
 */
export const WindfallProfileCardContent = ({ prospect, ...props }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [windfallProfile, setWindfallProfile] = useState(null);
    const displayable_fields = windfallProfile?.displayable_fields || {};
    const profileData = windfallProfile;

    const fetchProspectProfile = useCallback(() => {
        const id = prospect?.id;
        if (!id) return;
        const cached = profileCache.get(id);
        if (cached) {
            setWindfallProfile(cached);
            return;
        }
        setIsLoading(true);
        windfall_profile({ prospect_id: prospect.id, short_profile: true })
            .then((res) => {
                setWindfallProfile(res.data);
                profileCache.set(id, res.data);
                setIsLoading(false);
            })
            .catch((err) => {
                console.error('Error fetching windfall profile:', err);
                setIsLoading(false);
            });
    }, [prospect?.id]);
    useEffect(() => {
        fetchProspectProfile()
    }, [prospect?.id]);
    return (
        <div className="windfall-card">
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Avatar 
                    name={prospect?.name || prospect?.company} 
                    profile_image={prospect?.profile_image}
                    fullProfileImageView={false}
                />
                <div className="windfall-card__prospect-info">
                    <div className="body-m-bold windfall-card__name">
                        {prospect?.name || prospect?.company}
                    </div>
                    {(prospect?.headline || prospect?.designation) && (
                        <div className="body-s-semibold windfall-card__headline">
                            {prospect?.headline || prospect?.designation}
                        </div>
                    )}
                </div>
            </div>

            <div className="body-s-semibold windfall-card__section-title">
                Windfall information
            </div>
            {isLoading && (
                <div className="windfall-card__loader flex justify-center"><Loader isLoading={isLoading} Size="Large" /></div>
            )}
            {!isLoading && !profileData?.id && (
                <div className="body-m-semibold windfall-card__no-data">No Windfall Data Found</div>
            )}
            {!isLoading && profileData?.id && (
                <div>
                    {Object.keys(displayable_fields).map((key, index) => {
                        const item = displayable_fields[key]
                        const value = profileData[key] 
                        return (
                            <div key={key} className="windfall-card__field">
                                <div className="support-s-caps windfall-card__field-label">
                                {item.label}
                            </div>
                            <div className="body-s-semibold windfall-card__field-value">
                                {value || '\u00A0'}
                            </div>
                            {index !== Object.keys(displayable_fields).length - 1 && (
                                <div className="windfall-card__separator"></div>
                            )}
                        </div>
                    )})}
                    
                    <Button 
                        Type="Secondary"
                        Size="Small"
                        onClick={() => window.open(`/prospects/${prospect?.id}?tabType=windfall_profile`)}
                    >
                        Profile
                    </Button>
                </div>
            )}
        </div>
    );
};

export default WindfallProfileCardContent;